import { useCallback } from 'react';
import { rage } from '~/rage';
import { IModalReplyDefault, ModalButtonColor, ModalType } from '~/shared';
import {
	setFirstName,
	setLastName,
	useLayoutDispatch,
	useLayoutSelector,
} from '../redux';

const useSaveCharacter = () => {
	const dispatch = useLayoutDispatch();
	const firstName = useLayoutSelector(
		(state) => state.characterCreation.firstName,
	);
	const lastName = useLayoutSelector(
		(state) => state.characterCreation.lastName,
	);

	const gender = useLayoutSelector((state) => state.characterCreation.gender);
	const parentsValue = useLayoutSelector(
		(state) => state.characterCreation.parentsValue,
	);
	const faceMorphValues = useLayoutSelector(
		(state) => state.characterCreation.faceMorphValues,
	);
	const overlayValues = useLayoutSelector(
		(state) => state.characterCreation.overlayValues,
	);

	const handleCharacterCreationReply = useCallback(
		(result: IModalReplyDefault, firstName: string, lastName: string) => {
			if (!result.isAccepted) {
				return;
			}

			rage.characterCreation.createCharacter(firstName, lastName, {
				gender,
				parents: parentsValue,
				faceMorphs: faceMorphValues,
				overlays: overlayValues,
			});
		},
		[gender, parentsValue, faceMorphValues, overlayValues],
	);

	const handleShowCharacterCreationModal = useCallback(
		(firstName: string, lastName: string) => {
			rage.modal.showModal(
				{
					type: ModalType.Default,
					title: 'Подтверждение',
					text: 'Вы собираетесь создать персонажа с выбранной внешностью. Её можно будет изменить позже в процессе игры. Продолжить?',
					acceptButton: { text: 'Продолжить', color: ModalButtonColor.Primary },
					cancelButton: { text: 'Отменить', color: ModalButtonColor.Secondary },
				},
				(result) => handleCharacterCreationReply(result, firstName, lastName),
			);
		},
		[handleCharacterCreationReply],
	);

	const handleSave = useCallback(() => {
		if (!firstName.trim() || !lastName.trim()) {
			rage.notifications.showError('Введите имя и фамилию');
			return;
		}

		handleShowCharacterCreationModal(firstName, lastName);
	}, [handleShowCharacterCreationModal, firstName, lastName]);

	return {
		handleSave,
		firstName,
		setFirstname: (firstName: string) => dispatch(setFirstName(firstName)),
		lastName,
		setLastName: (lastName: string) => dispatch(setLastName(lastName)),
	};
};

export { useSaveCharacter };
